import React from "react";
import { Settings } from "lucide-react";
import Box from "../../../../../componentsv2/Box";
import Button from "../../../../../componentsv2/Button";
import TabelaV2 from "../../../../../componentsv2/Tabela";

export default function EnfermeirosTabela({ rows, loading, onAbrirOpcoes }) {
  const columns = [
    { field: "nome", headerName: "Nome", flex: 1, minWidth: 240 },
    { field: "username", headerName: "Login", width: 180 },
    {
      field: "opcoes",
      headerName: "Opções",
      width: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: params => (
        <Button
          variant="standard"
          onClick={() => onAbrirOpcoes(params.row)}
          style={{
            minWidth: "unset",
            width: "36px",
            height: "36px",
            borderRadius: "10px",
            padding: 0,
          }}
        >
          <Settings size={20} color="#7c8798" />
        </Button>
      ),
    },
  ];

  return (
    <Box sx={{ height: "600px", width: "100%" }}>
      <TabelaV2 rows={rows} columns={columns} loading={loading} autoPageSize />
    </Box>
  );
}
